import React from 'react'
import styled from 'styled-components'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'

export const NoticeBarStyled = styled.div`
    background: ${Variables.color.pazolaGold};
    position: absolute;
    bottom: 40px;
    left: 80px;
    z-index: 100;
    color: white;
    font-size: 20px;
    line-height: 120%;
    letter-spacing: 0.0015em;
    padding: 15px 20px;
    transform: translateY(-163px);
    font-weight: 500;
    ${media('<desktop')} {
        left: 20px;
        bottom: 170px;
        transform: none;
        font-size: 16px;
        font-weight: 600;
    }
`

const NoticeBar: React.FC<{
    message: string
}> = ({ message }) => {
    return <>{message && <NoticeBarStyled>{message}</NoticeBarStyled>}</>
}

export default NoticeBar
